import { ApplicantType } from 'shared'
import { isCorporateApplicant } from 'shared/ApplicationHelper'
import { CompanyCustomerForm, PersonCustomerForm } from '.'

interface ICustomerComponentProps {
  applicantType: ApplicantType,
}

export function CustomerTab({ applicantType }: ICustomerComponentProps) {
  const isCorporate = isCorporateApplicant(applicantType)
  return (
    <>
      {
        isCorporate && <CompanyCustomerForm />
      }
      {
        !isCorporate && <PersonCustomerForm />
      }
    </>
  )
}